interface BellIconProps {
  hasNotification?: boolean
  color?: string
}

export const IconBell = ({ hasNotification = false, color = '#efe9e9' }: BellIconProps) => (
  <span className="relative flex h-6 w-6 items-center justify-center">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* 벨 몸통: 24x24 기준 left/right 20.83%(5px), top 14.58%(3.5px), bottom 25%(6px) → 14×14.5 */}
      <svg x="5" y="3.5" width="14" height="14.5" viewBox="0 0 14 14.5" overflow="visible">
        <path d="M12 7C12 4.23858 9.76142 2 7 2C4.23858 2 2 4.23858 2 7V12.5H12V7ZM14 14.5H0V7C1.61069e-07 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7V14.5Z" fill={color} />
      </svg>
      {/* 꼭지 + 하단 선 + 방울: 24x24 기준 inset 8.33%(2px) → 18×20 */}
      <svg x="3" y="2" width="18" height="20" viewBox="0 0 18 20" overflow="visible">
        <path d="M8 2V1C8 0.447715 8.44772 0 9 0C9.55228 0 10 0.447715 10 1V2C10 2.55228 9.55228 3 9 3C8.44772 3 8 2.55228 8 2Z" fill={color} />
        <path d="M17 14C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H1C0.447715 16 0 15.5523 0 15C0 14.4477 0.447715 14 1 14H17Z" fill={color} />
        <path d="M6.29903 18.5049C6.41588 17.9206 6.9289 17.5 7.52476 17.5H10.4752C11.0711 17.5 11.5841 17.9206 11.701 18.5049C11.8557 19.2783 11.2641 20 10.4752 20H7.52475C6.73595 20 6.14433 19.2783 6.29903 18.5049Z" fill={color} />
      </svg>
    </svg>
    {hasNotification && (
      <span className="absolute right-0 top-0 h-2 w-2 rounded-full bg-primary-fire-brick" />
    )}
  </span>
)
